export const transformSubscriptionStatus = data => ({
	subscriptionStatus: data
})
